export class StoryController {
    constructor() {
        this.storyContainer = document.querySelector('.story-container');
        this.mainPanel = document.querySelector('.story-panel.active');
        this.contactPanel = document.querySelector('.contact-panel');
        this.closeBtn = null;
        this.onPanelChange = null;
        
        this.init();
    }

    init() {
        this.setupCloseButton();
        this.setupContactButton();
        this.setupKeyboardNavigation();
    }

    setupCloseButton() {
        // Wait for the buttons to be available in the DOM
        setTimeout(() => {
            this.closeBtn = document.getElementById('close-story');
            if (this.closeBtn) {
                this.closeBtn.addEventListener('click', () => {
                    this.hideStoryPanel();
                });
            }

            // X close buttons
            const storyCloseX = document.getElementById('story-close-x');
            const contactCloseX = document.getElementById('contact-close-x');
            
            if (storyCloseX) {
                storyCloseX.addEventListener('click', () => {
                    this.hideStoryPanel();
                });
            }
            
            if (contactCloseX) {
                contactCloseX.addEventListener('click', () => {
                    this.hideStoryPanel();
                });
            }
        }, 100);
    }

    setupContactButton() {
        setTimeout(() => {
            const contactBtn = document.getElementById('contact-reps-btn');
            const backBtn = document.getElementById('back-to-story');
            
            if (contactBtn) {
                contactBtn.addEventListener('click', () => {
                    this.showContactPanel();
                });
            }
            
            if (backBtn) {
                backBtn.addEventListener('click', () => {
                    this.showMainPanel();
                });
            }
        }, 100);
    }

    setupKeyboardNavigation() {
        document.addEventListener('keydown', (e) => {
            switch(e.key) {
                case 'Escape':
                    e.preventDefault();
                    if (this.contactPanel && !this.contactPanel.classList.contains('hidden')) {
                        this.showMainPanel();
                    } else {
                        this.hideStoryPanel();
                    }
                    break;
                case 'Enter':
                    if (e.target === this.closeBtn) {
                        e.preventDefault();
                        this.hideStoryPanel();
                    }
                    break;
            }
        });
    }

    showContactPanel() {
        if (this.mainPanel) {
            this.mainPanel.classList.add('hidden');
        }
        if (this.contactPanel) {
            this.contactPanel.classList.remove('hidden');
        }
        
        if (this.onPanelChange) {
            this.onPanelChange(1); // 1 indicates contact panel is active
        }
    }

    showMainPanel() {
        if (this.contactPanel) {
            this.contactPanel.classList.add('hidden');
        }
        if (this.mainPanel) {
            this.mainPanel.classList.remove('hidden');
        }
        
        if (this.onPanelChange) {
            this.onPanelChange(0); // 0 indicates main panel is active
        }
    }

    hideStoryPanel() {
        if (this.mainPanel) {
            this.mainPanel.classList.add('hidden');
        }
        if (this.contactPanel) {
            this.contactPanel.classList.add('hidden');
        }
        
        // Notify map controller that story is closed
        if (this.onPanelChange) {
            this.onPanelChange(-1); // -1 indicates story is closed
        }
    }

    showStoryPanel() {
        if (this.mainPanel) {
            this.mainPanel.classList.remove('hidden');
        }
        if (this.contactPanel) {
            this.contactPanel.classList.add('hidden');
        }
        
        if (this.onPanelChange) {
            this.onPanelChange(0);
        }
    }

    isVisible() {
        return (this.mainPanel && !this.mainPanel.classList.contains('hidden')) ||
               (this.contactPanel && !this.contactPanel.classList.contains('hidden'));
    }
}
